import { apiFetch } from '../lib/api';

// Apps API functions
export async function getApps(filters = {}) {
  const params = new URLSearchParams();
  
  // Add filters to query params
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });

  const queryString = params.toString();
  const url = queryString ? `/api/apps?${queryString}` : '/api/apps';
  
  const r = await apiFetch(url);
  if (!r.ok) throw new Error('Apps fetch failed');
  return r.json();
}

export async function getApp(id) {
  const r = await apiFetch(`/api/apps?id=eq.${id}&select=*`);
  if (!r.ok) throw new Error('App fetch failed');
  return r.json();
}

export async function createApp(appData) {
  const r = await apiFetch('/api/apps', {
    method: 'POST',
    body: JSON.stringify(appData)
  });
  if (!r.ok) throw new Error('App creation failed');
  return r.json();
}

export async function updateApp(id, appData) {
  const r = await apiFetch(`/api/apps?id=eq.${id}`, {
    method: 'PATCH',
    body: JSON.stringify(appData)
  });
  if (!r.ok) throw new Error('App update failed');
  return r.json();
}

export async function deleteApp(id) {
  const r = await apiFetch(`/api/apps?id=eq.${id}`, {
    method: 'DELETE'
  });
  if (!r.ok) throw new Error('App deletion failed');
  return r.json();
}

export async function getMyApps() {
  // Sadece kendi uygulamalarını çek - özel endpoint kullan
  const r = await apiFetch('/api/my-apps');
  if (!r.ok) throw new Error('My apps fetch failed');
  return r.json();
}
